// Content edit controls

import { default as Context } from './src/editor-context-provider/context';
import { default as Provider } from './src/editor-context-provider/components/async-editor-context-provider';
import { default as Component } from './src/editor-component/editor-context';

import InsertLinkDialogWindow from './src/editor-context-provider/components/editor-windows/insert-link-dialog-window';
import './src/editor-component/wa-bonaeditor';

import {
  InsertAnchorDialog,
  InsertLinkToAnchorDialog,
  InsertLinkDialog,
  InsertMacrosDialog,
  InsertResourceDialog
} from './src/content-edit-controls/index.jsx';
// eslint-disable-next-line import/no-named-default
import { default as displayMode } from './src/editor-component/constants/display-mode';
export { default as displayMode } from './src/editor-component/constants/display-mode';

export { default as WaBonaEditor } from './src/editor-component/wa-bonaeditor';

export const ContentEditControls = {
  InsertAnchorDialog,
  InsertLinkToAnchorDialog,
  InsertLinkDialog,
  InsertMacrosDialog,
  InsertResourceDialog
};

// Editor windows

export const ContentEditWindows = {
  InsertLinkDialogWindow
};

// Editor components

export const EditorComponent = {
  displayMode,
  Component
};

// Editor context provider

export const EditorContextProvider = {
  Context,
  Provider
};

export default {
  ContentEditControls,
  EditorComponent,
  EditorContextProvider
};
